'use strict';
import * as $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError from "./app.data.-Send-Email-Sign-In-Link-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_SendEmailSignInLinkError$Other(err) {
  this.Y9 = null;
  this.Y9 = err;
}
export { $c_Lapp_data_SendEmailSignInLinkError$Other as $c_Lapp_data_SendEmailSignInLinkError$Other };
$p = $c_Lapp_data_SendEmailSignInLinkError$Other.prototype = new $j_app$002edata$002e$002dSend$002dEmail$002dSign$002dIn$002dLink$002dError.$h_Lapp_data_SendEmailSignInLinkError();
$p.constructor = $c_Lapp_data_SendEmailSignInLinkError$Other;
/** @constructor */
function $h_Lapp_data_SendEmailSignInLinkError$Other() {
}
export { $h_Lapp_data_SendEmailSignInLinkError$Other as $h_Lapp_data_SendEmailSignInLinkError$Other };
$h_Lapp_data_SendEmailSignInLinkError$Other.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_SendEmailSignInLinkError$Other) && (this.Y9 === x$0.Y9)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Other";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y9;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 2;
});
function $isArrayOf_Lapp_data_SendEmailSignInLinkError$Other(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jX)));
}
export { $isArrayOf_Lapp_data_SendEmailSignInLinkError$Other as $isArrayOf_Lapp_data_SendEmailSignInLinkError$Other };
var $d_Lapp_data_SendEmailSignInLinkError$Other = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_SendEmailSignInLinkError$Other, "app.data.SendEmailSignInLinkError$Other", ({
  jX: 1,
  jW: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_SendEmailSignInLinkError$Other as $d_Lapp_data_SendEmailSignInLinkError$Other };
//# sourceMappingURL=app.data.-Send-Email-Sign-In-Link-Error$-Other.js.map
